import { Box, Button, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { faCalendarCheck } from '@fortawesome/pro-light-svg-icons'

import { BasicEmptyState } from '@scoir/empty-state'

import { useAppCycleYearRange } from '../AppRoundSection/app-round-helper'
import { AppRoundsGrid } from './AppRoundsGrid'
import AppRoundModalTrigger from './AppRoundModal'
import { useFocusedApplicationCycle, useIsPermittedToConfigure, useRounds } from '../AppRoundProvider'
import { useRequirements } from '../RoundRequirementsProvider'

export const noRequirementsOrDeadlinesTitle = 'Missing Requirements'
export const noRequirementsOrDeadlinesSubtitle = 'Before you can add a deadline, create a set of requirements above.'
export const noDeadlinesTitle = 'No deadlines added yet!'
export const noDeadlinesSubtitle = 'Get started by clicking "Create New Deadline" above.'

const useStyles = makeStyles((theme) => ({
  pageHeader: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: 500,
    marginBottom: theme.spacing(1),
  },
  pageSubheader: {
    fontSize: theme.typography.pxToRem(16),
  },
}))

const AppCycleRounds = () => {
  const classes = useStyles()
  const applicationCycle = useFocusedApplicationCycle()
  const appYearRange = useAppCycleYearRange(applicationCycle)
  const deadlines = useRounds()
  const requirements = useRequirements()
  const noRequirements = requirements.length === 0
  const noDeadlines = deadlines.length === 0
  const noRequirementsOrDeadlines = requirements.length === 0 && deadlines.length === 0
  const canConfigure = useIsPermittedToConfigure()
  return (
    <Box>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
        mb={3}
      >
        <Box mr={1}>
          <Typography
            variant="h6"
            component="h2"
            className={classes.pageHeader}
          >
            {appYearRange} Application Deadlines
          </Typography>
          <Typography
            variant="body2"
            className={classes.pageSubheader}
          >
            Create new deadlines or edit existing ones.
          </Typography>
        </Box>
        <Box>
          <AppRoundModalTrigger
            Component={Button}
            disabled={!canConfigure || noRequirements}
            color="primary"
            variant="contained"
          >
            Create New Deadline
          </AppRoundModalTrigger>
        </Box>
      </Box>
      {noRequirementsOrDeadlines || noDeadlines ? (
        <BasicEmptyState
          title={noRequirementsOrDeadlines ? noRequirementsOrDeadlinesTitle : noDeadlinesTitle}
          subTitle={noRequirementsOrDeadlines ? noRequirementsOrDeadlinesSubtitle : noDeadlinesSubtitle}
          icon={faCalendarCheck}
        />
      ) : (
        <AppRoundsGrid
          rounds={deadlines}
          canConfigure={canConfigure}
        />
      )}
    </Box>
  )
}

export default AppCycleRounds
